import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useDesktopBg from '../../hooks/useDesktopBg';
import './ThankYouPage.css';

function exitUrl(user) {
  return (
    user?.backButtonRedirect ||
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '/') ||
    '/'
  );
}

export default function ThankYouPage() {
  const user = useSelector((s) => s.auth.user);
  const bg = useDesktopBg(
    '/assets/img/background-mob.jpg',
    '/assets/img/background-web.jpg'
  );

  useEffect(() => {
    document.body.classList.add('bt-round-active');
    return () => document.body.classList.remove('bt-round-active');
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = exitUrl(user);
    }, 5000);
    return () => clearTimeout(t);
  }, [user]);

  return (
    <div className="bt-thankyou-page">
      <div
        className="bt-thankyou-fullbleed"
        style={{ backgroundImage: `url(${bg})` }}
        aria-hidden
      />
      <img src="/thankyou.gif" alt="Thank you" className="bt-thankyou-img" />
      <h1 className="bt-thankyou-title">Thank you for playing</h1>
      <p className="bt-thankyou-sub">Brain Teasers</p>
    </div>
  );
}
